import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { faFire } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { HOME } from '../../../../marketing/shared/constants';

const Header = ({ title }) => (
  <div className="flex items-center gap-2 self-center">
    <Link
      className="flex size-8 items-center justify-center rounded-lg bg-brand text-white"
      to={HOME}
    >
      <FontAwesomeIcon icon={faFire} />
    </Link>

    <span className="text-base font-medium">{title}</span>
  </div>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
